import accountIcon from "@iconify/icons-mdi/account";
import accountOutlineIcon from "@iconify/icons-mdi/account-cog-outline";
import accountOutIcon from "@iconify/icons-mdi/account-outline";
import Arrow from "@iconify/icons-mdi/arrow-right-bottom";
import bagIcon from "@iconify/icons-mdi/bag-personal";
import bagIconOutline from "@iconify/icons-mdi/bag-personal-outline";
import clockIcon from "@iconify/icons-mdi/clock";
import clockTimeFourIcon from "@iconify/icons-mdi/clock-time-four-outline";
import cafeteriaIcon from "@iconify/icons-mdi/coffee";
import cafeteriaSettingsIcon from "@iconify/icons-mdi/coffee-outline";
import settingsIcon from "@iconify/icons-mdi/cog";
import settingsOutlineIcon from "@iconify/icons-mdi/cog-outline";
import myNewsIcon from "@iconify/icons-mdi/newspaper-variant";
import myNewsAdminIcon from "@iconify/icons-mdi/newspaper-variant-outline";
import textBoxMultiple from "@iconify/icons-mdi/text-box-multiple";
import textBoxMultipleOutline from "@iconify/icons-mdi/text-box-multiple-outline";
import MyTimesheetIcon from "@iconify/icons-mdi/timer";
import MyTimesheetIconOutline from "@iconify/icons-mdi/timer-outline";
import { BADGE_TYPES } from "oc/components/sidebar/badge-registry";
import {
  LICENCES,
  ROLES,
  SidebarCollapse,
  SidebarItem,
  SidebarMenuItem,
} from "oc/configs/constants";
import { MENU_IDS } from "oc/configs/menu-constants";

export const myNewsMenu: SidebarItem = {
  id: "myNewsMenu",
  type: "item",
  path: "/my-news",
  label: "MyNews",
  icon: myNewsIcon,
  narrowMenuIcon: myNewsIcon,
  roles: [ROLES.MYNEWS.USER],
  rolesOnly: true,
  licence: LICENCES.MYHR,
};

export const mainMenuChangeRequestsDisabled: SidebarItem = {
  id: "myHr",
  type: "item",
  path: "/",
  label: "MyHR",
  icon: accountIcon,
  narrowMenuIcon: accountIcon,
  roles: [ROLES.MYHR.USER],
  rolesOnly: true,
  licence: LICENCES.MYHR,
};

export const mainMenuChangeRequestsEnabled: SidebarCollapse = {
  id: "myHRCollapse",
  type: "collapse",
  path: "",
  label: "MyHR",
  icon: accountIcon,
  badge: BADGE_TYPES.MY_HR_MENU,
  roles: [ROLES.MYHR.USER],
  licence: LICENCES.MYHR,
  children: [
    {
      id: "MyInfo",
      type: "item",
      path: "/",
      label: "MyInfo",
      roles: [ROLES.MYHR.USER],
      narrowMenuIcon: accountIcon,
      icon: Arrow,
    },
    {
      id: "myHrMyEditedData",
      type: "item",
      path: "/my-hr/my-requests",
      label: "My data edit request",
      translation: "MY_LEAVE_REQUESTS",
      icon: Arrow,
      narrowMenuIcon: accountIcon,
      roles: [ROLES.MYHR.USER],
    },
    {
      id: "DataEditRequestsView",
      type: "item",
      path: "/my-hr/view-requests",
      label: "Data edit requests",
      badge: BADGE_TYPES.MY_HR_MENU,
      icon: Arrow,
      translation: "OC_REQUESTS_VIEW",
      narrowMenuIcon: accountIcon,
      roles: [ROLES.MYHR.EXAMINER],
    },
  ],
};

export const mainMenuMyTimeRequestsDisabled: SidebarMenuItem = {
  id: "myTime",
  type: "item",
  path: "/",
  label: "MyTime",
  icon: clockIcon,
  roles: [ROLES.MYTIME.USER],
  rolesOnly: true,
};

export const mainMenuMyDocumentsViewer = {
  id: "myDocumentsViewer",
  type: "item",
  path: "/my-documents/view-documents",
  label: "MyDocuments",
  icon: textBoxMultiple,
  narrowMenuIcon: textBoxMultiple,
  roles: [ROLES.MYDOCUMENTS.VIEWER],
  rolesOnly: true,
  licence: LICENCES.MYDOCUMENTS,
};

export const mainMenuMyDocumentsUploader: SidebarMenuItem = {
  id: "myDocumentsUploader",
  type: "item",
  path: "/my-documents/upload-documents",
  label: "MyDocuments",
  icon: textBoxMultiple,
  narrowMenuIcon: textBoxMultiple,
  roles: [ROLES.MYDOCUMENTS.UPLOADER],
  rolesOnly: true,
  licence: LICENCES.MYDOCUMENTS,
};

export const mainMenuMyDocumentsCollapse: SidebarMenuItem = {
  id: "myDocumentsCollapse",
  type: "collapse",
  label: "MyDocuments",
  icon: textBoxMultiple,
  narrowMenuIcon: textBoxMultiple,
  roles: [ROLES.MYDOCUMENTS.UPLOADER, ROLES.MYDOCUMENTS.VIEWER],
  rolesOnly: true,
  licence: LICENCES.MYDOCUMENTS,
  children: [
    {
      id: "myDocumentsUploaderMenu",
      type: "item",
      path: "/my-documents/upload-documents",
      label: "Upload",
      translation: "OC_UPLOAD",
      icon: Arrow,
      narrowMenuIcon: textBoxMultiple,
      roles: [ROLES.MYDOCUMENTS.UPLOADER],
    },
    {
      id: "myDocumentsViewerMenu",
      type: "item",
      path: "/my-documents/view-documents",
      label: "View",
      translation: "OC_VIEWS",
      icon: Arrow,
      narrowMenuIcon: textBoxMultiple,
      roles: [ROLES.MYDOCUMENTS.VIEWER],
    },
  ],
};

export const mainMenuHeaderGroup: SidebarMenuItem = {
  id: "menuGroup",
  type: "group",
  label: "Menu",
  translation: "OC_MENU",
  roles: [ROLES.MYHR.USER],
  licence: LICENCES.MYHR,
};

export const myLeaveMenu: SidebarMenuItem[] = [
  {
    id: "myLeaveRequestItem",
    type: "item",
    path: "/my-leave/my-requests",
    label: "MyLeave",
    icon: bagIcon,
    narrowMenuIcon: bagIcon,
    roles: [ROLES.MYLEAVE.USER],
    notAllowedRoles: [
      ROLES.MYLEAVE.EXAMINER,
      ROLES.MYLEAVE.VIEWER,
      ROLES.MYLEAVE.ADMIN,
      ROLES.MYLEAVE.ASSIGNER,
    ],
    rolesOnly: true,
    licence: LICENCES.MYLEAVE,
  },
  {
    id: "myLeaveCollapse",
    type: "collapse",
    label: "MyLeave",
    icon: bagIcon,
    narrowMenuIcon: bagIcon,
    badge: BADGE_TYPES.MY_LEAVE_MENU,
    roles: [
      ROLES.MYLEAVE.EXAMINER,
      ROLES.MYLEAVE.VIEWER,
      ROLES.MYLEAVE.ADMIN,
      ROLES.MYLEAVE.ASSIGNER,
    ],
    rolesOnly: true,
    licence: LICENCES.MYLEAVE,
    children: [
      {
        id: "myDashboard",
        type: "item",
        path: "/my-leave/dashboard",
        label: "Examiner control panel",
        translation: "MY_LEAVE_EXAMINER_CONTROL_PANEL",
        narrowMenuIcon: bagIcon,
        icon: Arrow,
        roles: [ROLES.MYLEAVE.EXAMINER, ROLES.MYLEAVE.VIEWER, ROLES.MYLEAVE.ASSIGNER],
      },
      {
        id: "myLeaves",
        type: "item",
        path: "/my-leave/my-requests",
        label: "My leave request",
        translation: "MY_LEAVE_REQUESTS",
        narrowMenuIcon: bagIcon,
        icon: Arrow,
        roles: [ROLES.MYLEAVE.USER],
      },
      {
        id: "leaveRequestsApprove",
        type: "item",
        path: "/my-leave/approve-requests",
        label: "Leave requests",
        translation: "OC_APPROVE_REQUESTS",
        badge: BADGE_TYPES.MY_LEAVE_MENU,
        icon: Arrow,
        narrowMenuIcon: bagIcon,
        roles: [ROLES.MYLEAVE.EXAMINER],
      },
      {
        id: "leaveRequestsView",
        type: "item",
        path: "/my-leave/view-requests",
        label: "Leave requests",
        translation: "OC_REQUESTS_VIEW",
        narrowMenuIcon: bagIcon,
        icon: Arrow,
        roles: [ROLES.MYLEAVE.VIEWER],
      },
      {
        id: "leaveRequestsHandle",
        type: "item",
        path: "/my-leave/handle-requests",
        label: "Leave requests",
        translation: "MY_LEAVE_LEAVE_REQUESTS_HANDLE",
        badge: BADGE_TYPES.MY_LEAVE_ADMIN_MENU,
        icon: Arrow,
        narrowMenuIcon: bagIcon,
        roles: [ROLES.MYLEAVE.ADMIN],
      },
    ],
  },
];

export const myCafeteriaMenu: SidebarMenuItem = {
  id: "myCafeteria",
  type: "item",
  path: "/my-cafeteria",
  label: "MyCafeteria",
  icon: cafeteriaIcon,
  narrowMenuIcon: cafeteriaIcon,
  roles: [ROLES.MYCAFETERIA.USER],
  licence: LICENCES.MYCAFETERIA,
};

export const myTimeMenu: SidebarMenuItem = {
  id: "myTime",
  type: "item",
  path: "/my-time/employee-schedule",
  label: "MyTime",
  icon: clockIcon,
  narrowMenuIcon: clockIcon,
  roles: [ROLES.MYTIME.USER],
  notAllowedRoles: [ROLES.MYTIME.EXAMINER, ROLES.MYTIME.ADMIN],
  rolesOnly: true,
  licence: LICENCES.MYTIME,
};

export const myTimeCollapseMenu: SidebarMenuItem = {
  id: "myTimeCollapse",
  type: "collapse",
  label: "MyTime",
  icon: clockIcon,
  badge: BADGE_TYPES.MY_TIME_MENU,
  roles: [ROLES.MYTIME.EXAMINER, ROLES.MYTIME.ADMIN],
  rolesOnly: true,
  licence: LICENCES.MYTIME,
  children: [
    {
      id: "myTimeExaminerDashboard",
      type: "item",
      path: "/my-time/examiner-dashboard",
      label: "Dashboard",
      translation: "MY_TIME_DASHBOARD",
      roles: [ROLES.MYTIME.EXAMINER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
    },
    {
      id: "myTimeEmployeeSchedule",
      type: "item",
      path: "/my-time/employee-schedule",
      label: "MyRequests",
      translation: "MY_WORK_TIME_REPORTS",
      roles: [ROLES.MYTIME.USER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
    },
    {
      id: "myTimeApproveRequests",
      type: "item",
      path: "/my-time/approve-requests",
      label: "Requests",
      translation: "OC_REQUESTS",
      roles: [ROLES.MYTIME.EXAMINER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
      badge: BADGE_TYPES.MY_TIME_MENU,
    },
    {
      id: "myTimeClosingPeriod",
      type: "item",
      path: "/my-time/closing-current-period",
      label: "Requests",
      translation: "MY_TIME_CLOSING_PERIOD",
      roles: [ROLES.MYTIME.ADMIN],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
    },
  ],
};

export const myTimesheetMenu: SidebarMenuItem = {
  id: "myTimesheetCollapse",
  type: "collapse",
  label: "MyTimesheet",
  icon: MyTimesheetIcon,
  badge: BADGE_TYPES.MY_TIMESHEET_MENU,
  roles: [ROLES.MYTIMESHEET.USER, ROLES.MYTIMESHEET.EXAMINER, ROLES.MYTIMESHEET.VIEWER],
  rolesOnly: true,
  licence: LICENCES.MYTIMESHEET,
  children: [
    {
      id: "MyTimesheetMyRequests",
      type: "item",
      path: "/my-timesheet/my-requests",
      label: "MyRequests",
      translation: "MY_TIMESHEET_TIME_TRACKER",
      roles: [ROLES.MYTIMESHEET.USER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: MyTimesheetIcon,
    },
    {
      id: "MyTimesheetUserRequests",
      type: "item",
      path: "/my-timesheet/user-requests",
      label: "UserRequests",
      translation: "OC_APPROVE_REQUESTS",
      roles: [ROLES.MYTIMESHEET.EXAMINER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
      badge: BADGE_TYPES.MY_TIMESHEET_MENU,
    },
    {
      id: "MyTimesheetUserRequestsView",
      type: "item",
      path: "/my-timesheet/user-requests-view",
      label: "ViewUserRequests",
      translation: "OC_REQUESTS_VIEW",
      roles: [ROLES.MYTIMESHEET.VIEWER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
    },
    {
      id: "MyTimesheetMyRequestsDashboard",
      type: "item",
      path: "/my-timesheet/my-requests-dashboard",
      label: "Requests",
      translation: "MY_TIMESHEET_TIMESHEET",
      roles: [ROLES.MYTIMESHEET.USER],
      notAllowedRoles: [ROLES.MYTIMESHEET.EXAMINER, ROLES.MYTIMESHEET.VIEWER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
    },
    {
      id: "MyTimesheetExaminerDashboard",
      type: "item",
      path: "/my-timesheet/examiner-dashboard",
      label: "Requests",
      translation: "MY_TIMESHEET_TIMESHEET",
      roles: [ROLES.MYTIMESHEET.EXAMINER, ROLES.MYTIMESHEET.VIEWER],
      rolesOnly: true,
      icon: Arrow,
      narrowMenuIcon: clockIcon,
    },
  ],
};

export const mainMenuSettingsMenu: SidebarMenuItem = {
  id: "settingCollapse",
  type: "collapse",
  label: "Settings",
  translation: "OC_SETTINGS",
  icon: settingsIcon,
  roles: [ROLES.MYHR.USER],
  licence: LICENCES.MYHR,
  children: [
    {
      id: "myProfile",
      type: "item",
      path: "/my-hr/my-profile",
      label: "My profile",
      translation: "MY_HR_MY_PROFILE",
      narrowMenuIcon: settingsIcon,
      roles: [ROLES.MYHR.USER],
      icon: Arrow,
    },
    {
      id: "userGuides",
      type: "item",
      path: "/my-hr/user-guides",
      label: "User guides",
      translation: "MY_HR_USER_GUIDES",
      narrowMenuIcon: settingsIcon,
      roles: [ROLES.MYHR.USER],
      icon: Arrow,
    },
    {
      id: "settingsSubmenu",
      type: "submenu",
      label: "System",
      translation: "MY_HR_SYSTEM",
      roles: [
        ROLES.MYHR.ADMIN,
        ROLES.MYCAFETERIA.ADMIN,
        ROLES.MYTIME.ADMIN,
        ROLES.MYNEWS.ADMIN,
        ROLES.MYTIMESHEET.ADMIN,
      ],
      icon: Arrow,
    },
  ],
};

export const settingsSubmenu: SidebarMenuItem[] = [
  {
    id: "backToMainMenu",
    type: "backMenu",
    targetMenu: MENU_IDS.MAIN,
    label: "Menü",
    translation: "OC_MENU",
    roles: [
      ROLES.MYHR.ADMIN,
      ROLES.MYCAFETERIA.ADMIN,
      ROLES.MYTIME.ADMIN,
      ROLES.MYTIMESHEET.ADMIN,
      ROLES.MYNEWS.ADMIN,
    ],
    licence: LICENCES.MYHR,
  },
  {
    id: "systemGroup",
    type: "group",
    label: "System",
    translation: "MY_HR_SYSTEM",
    roles: [ROLES.MYHR.ADMIN],
    licence: LICENCES.MYHR,
  },
  {
    id: "users",
    type: "item",
    path: "/my-hr/users",
    label: "Users",
    translation: "MY_HR_USERS",
    icon: accountOutlineIcon,
    narrowMenuIcon: accountOutlineIcon,
    roles: [ROLES.MYHR.ADMIN],
    licence: LICENCES.MYHR,
  },
  {
    id: "systemSettings",
    type: "item",
    path: "/my-hr/system-settings",
    label: "System settings",
    translation: "MY_HR_SYSTEM_SETTINGS",
    icon: settingsOutlineIcon,
    narrowMenuIcon: settingsOutlineIcon,
    roles: [ROLES.MYHR.ADMIN],
    licence: LICENCES.MYHR,
  },
  {
    id: "myLeaveGroup",
    type: "group",
    label: "Module",
    translation: "OC_MODULE",
    roles: [
      ROLES.MYCAFETERIA.ADMIN,
      ROLES.MYHR.ADMIN,
      ROLES.MYTIME.ADMIN,
      ROLES.MYTIMESHEET.ADMIN,
      ROLES.MYNEWS.ADMIN,
    ],
    licence: LICENCES.MYHR,
  },
  {
    id: "myNewsSettings",
    type: "item",
    path: "/my-news/admin/settings",
    label: "MyNews",
    icon: myNewsAdminIcon,
    narrowMenuIcon: myNewsAdminIcon,
    roles: [ROLES.MYNEWS.ADMIN],
    licence: LICENCES.MYHR,
  },
  {
    id: "myHrSettings",
    type: "item",
    path: "/my-hr/admin/settings",
    label: "MyHR",
    icon: accountOutIcon,
    narrowMenuIcon: accountOutIcon,
    roles: [ROLES.MYHR.ADMIN],
    licence: LICENCES.MYHR,
  },
  {
    id: "myLeaveSettings",
    type: "item",
    path: "/my-leave/admin/settings",
    label: "MyLeave",
    icon: bagIconOutline,
    narrowMenuIcon: bagIconOutline,
    roles: [ROLES.MYHR.ADMIN],
    licence: LICENCES.MYLEAVE,
  },
  {
    id: "myCafeteriaSettings",
    type: "item",
    path: "/my-cafeteria/admin/settings",
    label: "MyCafeteria",
    icon: cafeteriaSettingsIcon,
    narrowMenuIcon: cafeteriaSettingsIcon,
    roles: [ROLES.MYCAFETERIA.ADMIN],
    licence: LICENCES.MYCAFETERIA,
  },
  {
    id: "myTimeSettings",
    type: "item",
    path: "/my-time/admin/settings",
    label: "MyTime",
    icon: clockTimeFourIcon,
    narrowMenuIcon: clockTimeFourIcon,
    roles: [ROLES.MYTIME.ADMIN],
    licence: LICENCES.MYTIME,
  },
  {
    id: "mySheetAdminSettings",
    type: "item",
    path: "/my-timesheet/admin/settings",
    label: "MyTimesheet",
    icon: MyTimesheetIconOutline,
    narrowMenuIcon: MyTimesheetIconOutline,
    roles: [ROLES.MYTIMESHEET.ADMIN],
    licence: LICENCES.MYHR,
  },
  {
    id: "myDocumentsSettings",
    type: "item",
    path: "/my-documents/settings",
    label: "MyDocuments",
    icon: textBoxMultipleOutline,
    narrowMenuIcon: textBoxMultipleOutline,
    roles: [ROLES.MYHR.ADMIN],
    licence: LICENCES.MYDOCUMENTS,
  },
];
